export default __webpack_public_path__ + "static/media/visa.353b3b9a.svg";